import React from "react";
import { Box, Typography, Dialog, IconButton } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { useGlobalModalContext } from "../context/GlobalModalContext";

const CompanyProfileCard = ({ setShowCompanySubTab, data }) => {
  const { showModal, hideModal } = useGlobalModalContext();

  const handleSubView = () => {
    setShowCompanySubTab(true);
  };

  const companyData = data && data.length > 0 ? data[0] : null;

  return (
    <Box
      className="rounded-md py-2 px-4"
      style={{
        boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.1)",
        height: "60vh",
        overflowY: "auto",
      }}
    >
      <div className="flex justify-between items-center">
        <div className="text-main font-bold text-left text-xs"></div>
        <IconButton
          aria-label="<>"
          onClick={handleSubView}
          sx={{ height: 24, width: 24 }}
        >
          <ArrowForwardOutlinedIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </div>

      <div className="grid grid-cols-2 gap-y-3">
        <div className="text-black font-bold text-xs">Group Company Name</div>
        <div className="text-[#00555C] text-xs">
          {companyData?.["Group Company Name"] || "..."}
        </div>

        <div className="text-black font-bold text-xs">Company Name</div>
        <div className="text-[#00555C] text-xs">
          {companyData?.["Company Name"] || "..."}
        </div>

        <div className="text-black font-bold text-xs">Industry</div>
        <div className="text-[#00555C] text-xs">
          {companyData?.Industry || "..."}
        </div>

        <div className="text-black font-bold text-xs">Sub-Industry</div>
        <div className="text-[#00555C] text-xs">
          {companyData?.["Sub-Industry"] || "..."}
        </div>

        <div className="text-black font-bold text-xs">Segment</div>
        <div className="text-[#00555C] text-xs">
          {companyData?.["Segment Name"] || "..."}
        </div>

        <div className="text-black font-bold text-xs">No. of Employees</div>
        <div className="text-[#00555C] text-xs">
          {companyData?.["no_of_employees"] || "..."}
        </div>

        <div className="text-black font-bold text-xs">Ownership Structure</div>
        <div className="text-[#00555C] text-xs">
          {Array.isArray(companyData?.ownership_structure) ? (
            companyData.ownership_structure.map((owner, index) => (
              <li key={index}>
                {owner.Shareholder} : {owner.Percentage}
              </li>
            ))
          ) : typeof companyData?.ownership_structure === "object" &&
            companyData?.ownership_structure !== null ? (
            <>
              <li>
                {companyData.ownership_structure.Shareholder} :{" "}
                {companyData.ownership_structure.Percentage}
              </li>
              <div>Shares : {companyData.ownership_structure?.Shares}</div>
            </>
          ) : (
            "..."
          )}
        </div>

        <div className="text-black font-bold text-xs">Registered Address</div>
        <div className="text-[#00555C] text-xs">
          {companyData?.["registered_address"] || "..."}
        </div>

        <div className="text-black font-bold text-xs">
          Banking Relationship POC Name
        </div>
        <div className="text-[#00555C] text-xs">
          {companyData?.["Banking Relationship POC Name"] || "..."}
        </div>

        <div className="text-black font-bold text-xs">
          Banking Relationship POC Contact Details
        </div>
        <div className="text-[#00555C] text-xs">
          {companyData?.["Banking Relationship POC Contact Details"] || "..."}
        </div>
      </div>
    </Box>
  );
};

export default CompanyProfileCard;
